import { HttpInterceptorFn, HttpRequest, HttpResponseBase } from '@angular/common/http';
import { inject } from '@angular/core';

import { SportsApiVersionConfig } from '@frontend/sports/common/client-config-data-access';
import { CustomWindow, WINDOW } from '@frontend/vanilla/core';
import { catchError, throwError } from 'rxjs';

export const apiVersioningInterceptor: HttpInterceptorFn = (req, next) => {
    if (!isSportsApiRequest(req)) {
        return next(req);
    }

    const sportsApiVersionConfig = inject(SportsApiVersionConfig);
    const window = inject(WINDOW);

    const versionedRequest = req.clone({
        headers: req.headers.set(sportsApiVersionConfig.sportsApiVersionHeaderName, sportsApiVersionConfig.sportsApiVersion),
    });

    return next(versionedRequest).pipe(
        catchError((response: unknown) => {
            if (response instanceof HttpResponseBase) {
                processHttpResponse(response, sportsApiVersionConfig, window);
            }

            return throwError(response);
        }),
    );
};

function processHttpResponse(response: HttpResponseBase, sportsApiVersionConfig: SportsApiVersionConfig, _window: CustomWindow): HttpResponseBase {
    if (isCachedResponse(response)) {
        return response;
    }

    const newApiVersion = response?.headers?.get(sportsApiVersionConfig.sportsApiVersionHeaderName);
    if (newApiVersion && newApiVersion !== sportsApiVersionConfig.sportsApiVersion) {
        _window.location.reload();
    }

    return response;
}

function isCachedResponse(response: HttpResponseBase): boolean {
    const cacheControlHeader = response.headers?.get('cache-control');

    return !!cacheControlHeader && cacheControlHeader !== 'no-cache';
}

function isSportsApiRequest(req: HttpRequest<unknown>): boolean {
    return req.url.includes('/sports/api/');
}
